/**
 * The Users screen's tabs, in one place.
 *
 * They are named here rather than inside the screen because TWO surfaces render
 * them now: the in-page tab bar, and the header nav's Users dropdown. A tab
 * added in one and forgotten in the other is the obvious failure mode, so both
 * build from this list.
 *
 * Each tab is also a URL — `/users/<slug>` — which is what lets the header menu
 * link straight to one and what makes the active-state highlight work. `all`
 * rather than `users` for the first slug so no path is a prefix of another
 * (`/users` would otherwise match every sibling and light them all at once).
 * Bare `/users` still resolves, to the first tab.
 */
export const USERS_TABS = [
  { value: "users", slug: "all", label: "All Users" },
  { value: "sessions", slug: "sessions", label: "Active Sessions" },
  { value: "groups", slug: "groups", label: "Groups" },
  // Visible only to members of the "User Activity" org group — see
  // hooks/useIsInUserActivityGroup.js. Both renderers must honour this.
  {
    value: "activity",
    slug: "activity",
    label: "Activity",
    requiresUserActivityGroup: true,
  },
];

export const DEFAULT_USERS_TAB = USERS_TABS[0];

export const usersTabPath = (slug) => `/users/${slug}`;

export const viewFromSlug = (slug) =>
  USERS_TABS.find((t) => t.slug === slug)?.value || DEFAULT_USERS_TAB.value;

export const slugFromView = (view) =>
  USERS_TABS.find((t) => t.value === view)?.slug || DEFAULT_USERS_TAB.slug;

/** The tabs this user may actually see. */
export const visibleUsersTabs = ({ canSeeActivity }) =>
  USERS_TABS.filter((t) => !t.requiresUserActivityGroup || canSeeActivity);
